import api from 'api';
import { OfficeMedicalStaff } from 'models/office-medical-staff.model';
import { Prescription } from 'models/prescription.model';
import RoutePaths from 'utils/RoutePaths';

interface CreatePrescriptionParams {
  patientId: number;
  omsId: number;
  navigation: (to: string, params?: {}) => void;
  poct?: boolean;
}

const createPrescription = ({ patientId, omsId, navigation, poct }: CreatePrescriptionParams) => {
  api.prescriptions.postBasketPrescription(patientId, omsId).then((response) => {
    const routeParams = {
      id: response.id,
      poct,
    };
    const baseLink = RoutePaths['DOCTOR_PRESCRIPTION_DETAILS'](routeParams);
    navigation(baseLink);
  });
};

interface PrescriptionRequestMakerParams {
  patientId: number;
  navigation: (to: string, params?: {}) => void;
  selectedOfficeStaff?: number;
  poct?: boolean;
}

export const PrescriptionRequestMaker = ({ patientId, navigation, selectedOfficeStaff, poct }: PrescriptionRequestMakerParams) => {
  if (selectedOfficeStaff) {
    createPrescription({ patientId, omsId: selectedOfficeStaff, navigation, poct });
  } else {
    api.users.getAllOfficeMedicalStaffByUser().then((idResponse) => {
      //If more than one office, we must ask the user to select one
      if (idResponse.length > 1) {
        const link = RoutePaths['DOCTOR_SELECT_OMS']({
          id: patientId,
          poct,
        });
        navigation(link);
      } else {
        createPrescription({ patientId, omsId: idResponse[0].id, navigation, poct });
      }
    });
  }
};

export const officeMedicalStaffInfoToString = (officeMedicalStaff: OfficeMedicalStaff) => {
  return `${officeMedicalStaff.medical_staff.title ?? ''} ${officeMedicalStaff.medical_staff.last_name} ${officeMedicalStaff.medical_staff.first_name} (${
    officeMedicalStaff.address?.number ?? ''
  } ${officeMedicalStaff.address?.street}, ${officeMedicalStaff.address?.postal_code} ${officeMedicalStaff.address?.city})`;
};

export const hasPoctAnalysis = (prescription: Prescription): boolean => {
  return prescription.items.some((item) => item.title.toUpperCase().includes('POCT'));
};
